/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 08/06/2021
 *
 * @version 0.2
 * Revisions:
 * 08/06/2021 - BW - Initial Creation
 * 04/05/2022 - BW - Added: outstandingAmount
 *
 * Description/Purpose:
 * Case Menu Count JSON DTO
 ************************************************************** */

export default class CaseMenuCountJsonDto {
  constructor(obj) {
    if (obj) Object.assign(this, obj);
  }

  get caseCalendarCount() {
    return this._caseCalendarCount;
  }

  set caseCalendarCount(value) {
    this._caseCalendarCount = value;
  }

  get categoryViewCount() {
    return this._categoryViewCount;
  }

  set categoryViewCount(value) {
    this._categoryViewCount = value;
  }

  get dateViewCount() {
    return this._dateViewCount;
  }

  set dateViewCount(value) {
    this._dateViewCount = value;
  }

  get depositionViewCount() {
    return this._depositionViewCount;
  }

  set depositionViewCount(value) {
    this._depositionViewCount = value;
  }

  get documentProductionViewCount() {
    return this._documentProductionViewCount;
  }

  set documentProductionViewCount(value) {
    this._documentProductionViewCount = value;
  }

  get fileExportCount() {
    return this._fileExportCount;
  }

  set fileExportCount(value) {
    this._fileExportCount = value;
  }

  get formCount() {
    return this._formCount;
  }

  set formCount(value) {
    this._formCount = value;
  }

  get hearingViewCount() {
    return this._hearingViewCount;
  }

  set hearingViewCount(value) {
    this._hearingViewCount = value;
  }

  get masterCalendarCount() {
    return this._masterCalendarCount;
  }

  set masterCalendarCount(value) {
    this._masterCalendarCount = value;
  }

  get messageBoardCount() {
    return this._messageBoardCount;
  }

  set messageBoardCount(value) {
    this._messageBoardCount = value;
  }

  get personalCalendarCount() {
    return this._personalCalendarCount;
  }

  set personalCalendarCount(value) {
    this._personalCalendarCount = value;
  }

  get outstandingAmount() {
    return this._outstandingAmount;
  }

  set outstandingAmount(value) {
    this._outstandingAmount = value;
  }
}
